/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var accordions = document.querySelectorAll('.accordion');
  if(accordions) {
    accordions.forEach((accordion) => {
      var accordion_button = accordion.querySelector('.accordion-title'),
          accordion_content = accordion.querySelector('.accordion-content');

      accordion_button.addEventListener('click', (e) => {
        e.preventDefault();

        var is_open = accordion.classList.contains('open');

        if(!is_open) {
          accordion.classList.add('open');
          accordion_button.setAttribute('aria-expanded', 'true');
          accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
        } else {
          accordion.classList.remove('open');
          accordion_button.setAttribute('aria-expanded', 'false');
          accordion_content.style.maxHeight = null;
        }
      });

      window.addEventListener('resize', () => {
        var is_open = accordion.classList.contains('open');

        if(is_open) {
          accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
        }
      });
    });
  }
}());